<template>
  <div class="login-box">
    <div class="login-logo">
      <div class="welcometitle">
        <span class="logo" style="justify-content:center" v-html="logos"></span>
      </div>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <div class="box-header fgpswd with-border mb-10" v-if="!isHidden">
        <h4 class="box-title pull-left fgpswd">Forgotten your password?</h4>
      </div>
      <form method="post" v-if="!isHidden">
        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input
            v-model="form.userEmail"
            type="email"
            class="form-control inputfield"
            id="email"
            name="email"
            aria-describedby="emailHelp"
            placeholder="Enter email"
            :class="{ 'is-invalid': submitted && $v.form.userEmail.$error }"
          />
          <div
            v-if="submitted"
            class="invalid-feedback"
            style="color:red"
          >
            <span v-if="!$v.form.userEmail.required">Email is required*</span>
            <span v-if="$v.form.userEmail.required && errormsg">Email is invalid*</span>
          </div>
        </div>

        <br />
        <div class="signinbtn">
          <button
            type="button"
            class="btn btn-success"
            style="width:100%"
            @click="onsubmit(), toggle = !toggle"
          >
            Get OTP
          </button>
        </div>
      </form>
      <br />
      <form method="post" v-if="verifyPassword">
        <div class="form-group">
          <div class="VerifyOtp" id="hide">
            <h4>Verification Code</h4>
            <hr />
            <p>
              OTP has been sent your registered email, Please enter to verify
            </p>
            <fieldset class='number-code'>
    <div class="userInput">
<input v-model="manualotp1" type="text" v-on:keyup="changefocus(1)" v-on:keypress="NumbersOnly" class="otp" id='otp1' maxlength="1">
<input v-model="manualotp2" type="text" v-on:keyup="changefocus(2)" v-on:keypress="NumbersOnly" class="otp" id="otp2" maxlength="1">
<input v-model="manualotp3" type="text" v-on:keyup="changefocus(3)" v-on:keypress="NumbersOnly" class="otp" id="otp3" maxlength="1">
<input v-model="manualotp4" type="text" v-on:keyup="changefocus(4)" v-on:keypress="NumbersOnly" class="otp" id="otp4" maxlength="1">
<input v-model="manualotp5" type="text" v-on:keyup="changefocus(5)" v-on:keypress="NumbersOnly" class="otp" id="otp5" maxlength="1" >
<input v-model="manualotp6" type="text" v-on:keyup="changefocus(6)" v-on:keypress="NumbersOnly" class="otp" id="otp6" maxlength="1">
</div>
  <p v-if="invalidOTP" class="tc" style="color:red">Invalid OTP</p>
  </fieldset>
  <br><button to="/Interviewer_BasicProfile" type="button" class="btn btn-success" style="width:50%" v-on:click.prevent="verify">Verify</button>
            <br /><br />
            <p style="text-align: center;">
              Didn't receive it?
              <button
                class="btn"
                @click="onsubmit(2)"
                style="background:transparent; color:#5BAD2B"
              >
                Resend Code
              </button>
            </p>
          </div>
        </div>
      </form>
      <div class="setPassword">
        <div>
          <form
            @submit.prevent="savePassword()"
            novalidate
            method="post"
            v-if="setPswd"
          >
            <div class="form-group" style="color:red">
              <input
                :type="passwordFieldType"
                class="form-control"
                placeholder="Enter Password"
                value=""
                v-model="form.password"
                autocomplete="new-password"
              />
              <span
                class="uil uil-eye form-control-feedback"
                v-if="passwordFieldType == 'text'"
                @click="switchVisibility"
              ></span>
              <span
                class="uil uil-eye-slash form-control-feedback"
                v-if="passwordFieldType == 'password'"
                @click="switchVisibility"
              ></span>
              <p style="font-size: 11px" class="error-msg" v-if="$v.form.password.required && !chkState('password')">
                <span>* Must have 8 characters with 1 upper case letter, 1 number & 1 special character</span></p>
              <div
                v-if="this.submitted && $v.form.password.$error"
                class="invalid-feedback left"
              >
                <span v-if="!$v.form.password.required"
                  >Password is required</span
                >
                <!-- <span v-if="form.password && !$v.form.password.minLength"
                  >Password must be minimum 8 characters</span
                > -->
              </div>
            </div>
            <div class="form-group" style="color:red">
              <input
                :type="passwordFieldType1"
                class="form-control"
                placeholder="Confirm Password"
                value=""
                v-model="form.confirmPassword"
                autocomplete="off"
              />
              <span
                class="uil uil-eye form-control-feedback"
                v-if="passwordFieldType1 == 'text'"
                @click="switchVisibility1"
              ></span>
              <span
                class="uil uil-eye-slash form-control-feedback"
                v-if="passwordFieldType1 == 'password'"
                @click="switchVisibility1"
              ></span>
              <div
                v-if="this.submitted && $v.form.confirmPassword.$error"
                class="invalid-feedback left"
              >
                <span v-if="!$v.form.confirmPassword.required"
                  >Confirm Password is required</span
                >
                <span
                  v-if="
                    form.confirmPassword &&
                      !$v.form.confirmPassword.sameAsPassword
                  "
                  >Password and Confirm Password should match</span
                >
              </div>
            </div>
            <br />
            <input
              type="submit"
              class="btnRegister"
              value="Save"
            />
          </form>
        </div>
      </div>
    </div>
    <!-- /.login-box-body -->
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import { BaseURL } from '../../shared/classes'
import axios from 'axios'
import { logo } from '../../shared/svg_forget'
import $ from 'jquery'
export default {
  data () {
    return {
      form: {
        userEmail: '',
        verifyOtp: '',
        password: '',
        confirmPassword: ''
      },
      logos: logo,
      password_token: '',
      submitted: false,
      isHidden: false,
      setPswd: false,
      toggle: false,
      verifyPassword: false,
      totalOtp: '',
      invalidOTP: false,
      otpvalue: '',
      manualotp1: '',
      manualotp2: '',
      manualotp3: '',
      manualotp4: '',
      manualotp5: '',
      manualotp6: '',
      sendOtp: '',
      passwordFieldType: 'password',
      passwordFieldType1: 'password',
      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      errormsg: false

    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      userEmail: {
        required,
        email,
        minLength: minLength(5)
      },
      password: {
        required,
        minLength: minLength(8),
        strongPassword (userpassword) {
          return (
            /[a-z]/.test(userpassword) && // checks for a-z
            /[0-9]/.test(userpassword) && // checks for 0-9
            /\W|_/.test(userpassword) && // checks for special char
            userpassword.length >= 8
          )
        }
      },
      confirmPassword: { required, sameAsPassword: sameAs('password') }
    }
  },
  created () {
    localStorage.setItem('setPassword', JSON.stringify(false))
    localStorage.getItem('token')
    localStorage.getItem('type_of_account')
    return this.$v.$touch()
  },
  methods: {
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some(child => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    switchVisibility1 () {
      this.passwordFieldType1 =
        this.passwordFieldType1 === 'password' ? 'text' : 'password'
    },
    switchVisibility () {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    changefocus (len) {
      var next = Number(len) + 1
      console.log(next)
      if ($('#otp' + len).val()) {
        this.invalidOTP = false
        $('#otp' + next).focus()
      }
    },
    NumbersOnly (evt) {
      evt = evt || window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    savePassword () {
      this.submitted = true
      if (this.validate()) {
        this.$nextTick(() => {
          if (this.form.password === this.form.confirmPassword) {
            // this.isDisabled = false
            // this.isHidden = true
            // this.toggle = !this.toggle
            // this.submitted = false
            const data = {
              userEmail: this.form.userEmail,
              password: this.form.password,
              userToken: this.password_token,
              oldpassword: ''
            }
            axios.post(BaseURL + '/profile/setPassword', { formData: data }).then(response => {
              console.log(response)
              if (response.data.message === 'Success') {
                localStorage.setItem(
                  'password',
                  JSON.stringify(this.form.password)
                )
                this.$awn.success('Password Changed successfully')
                this.$router.push('/LoginPage')
              } else {
                this.$awn.success(response.data.message)
              }
            })
          } else {
            // alert('Password and Confirm Password should match')
            this.$awn.success('Password and Confirm Password should match')
          }
        })
      }
    },
    verify () {
      this.invalidOTP = false
      this.submitted = true
      this.totalOtp = Number(
        this.manualotp1 +
          this.manualotp2 +
          this.manualotp3 +
          this.manualotp4 +
          this.manualotp5 +
          this.manualotp6
      )
      console.log(this.totalOtp)
      if (!this.otpvalue) {
        alert('Please enter OTP')
      } else if (this.otpvalue === this.totalOtp) {
        // this.$router.push('/Interviewer_BasicProfile')
        // alert('OTP Verified')
        this.$awn.success('OTP Verified Successfully')
        this.$v.$reset()
        this.verifyPassword = false
        this.setPswd = true
      } else {
        this.verifyPassword = true
        this.setPswd = false
        // this.$awn.success('Invalid OTP')

        this.manualotp1 = ''
        this.manualotp2 = ''
        this.manualotp3 = ''
        this.manualotp4 = ''
        this.manualotp5 = ''
        this.manualotp6 = ''
        this.invalidOTP = true
      }
    },
    onsubmit () {
      this.submitted = true
      if (this.form.userEmail === '') {
        this.toggle = false
      } else {
        const formData = new FormData()
        formData.append('user_email', this.form.userEmail)
        console.log(this.form.userEmail)
        const data = {
          user_email: this.form.userEmail.toLowerCase(),
          type_of_account: localStorage.getItem('type_of_account')
        }
        axios.post(BaseURL + '/email/update/user/using/email/mobile_new', { formData: data },
          this.config
        )
          .then(response => {
            this.statusMsg = response.data.message
            console.log('mail status msg', this.statusMsg)
            if (this.statusMsg === 'Email not exist!') {
              this.errormsg = true
              // console.log(this.errormsg)
            } else {
              this.isHidden = true
              this.verifyPassword = true
              this.otpvalue = Number(response.data.userdetail.pwd_otp)
              this.password_token =
            response.data.userdetail.password_access_token
              localStorage.setItem('pass_token', this.password_token)
              console.log(this.otpvalue)
              localStorage.setItem('token', this.token)
              localStorage.setItem('user_email', this.form.userEmail)
              this.$awn.success('OTP sent to Mail successfully')
            }
          })
      }
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    },
    isDisabled () {
      return this.$v.$invalid
    }
  },
  mounted: function () {
    $('.inputs').keyup(function () {
      if (this.value.length === this.maxLength) {
        $(this).next('.inputs').focus()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.fgpswd {
  text-align: center;
}
.VerifyOtp {
  text-align: center;
}
.userInput {
  display: flex;
  justify-content: center;
}
.otp {
  margin: 10px;
  height: 35px;
  width: 50px;
  border: none;
  border-radius: 5px;
  text-align: center;
  font-family: arimo;
  font-size: 16;
  font-weight: 700;
  background: #eef2f3;
}
.btnRegister {
  background: #5bad2b;
  color: white;
}
@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
  .otp {
  margin: 6px;
  height: 45px;
  width: 40px;
padding: 4px;
}
}
  @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
  }
    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
       .otp {
  margin: 6px;
  height: 45px;
  width: 40px;
padding: 4px;
}
    }
</style>
